import dayjs from 'dayjs';
import 'dayjs/locale/fr';

dayjs.locale('fr');

export const fmtTime = (iso: string) => dayjs(iso).format('HH:mm');
export const fmtDayLong = (iso: string) => dayjs(iso).format('dddd D MMMM YYYY');
export const fmtDayShort = (iso: string) => dayjs(iso).format('dddd D MMMM');
export const fmtDate = (iso: string) => dayjs(iso).format('DD/MM/YYYY');
export const isSameDay = (a: string, b: string) =>
  dayjs(a).isSame(dayjs(b), 'day');
export const isToday = (iso: string) => dayjs(iso).isSame(dayjs(), 'day');

export const initials = (first: string, last: string) =>
  `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();

export default dayjs;
